module.exports = __webpack_public_path__ + "assets/img/Resources@2x.ac402ee1.png";